import hashData from "./hashData";

const hasFlowChanged = async (prevFlow, newFlow) => {
    const filteredPrevNodes = prevFlow.nodes.map((node) => {
        const { showHandle, ...filteredData } = node.data; // ลบ showHandle ออกจาก data
        const {
            activeSourceHandleId,
            activeTargetHandleId,
            highlighted,
            ...withoutHandleActive
        } = filteredData;
        return { id: node.id, data: withoutHandleActive, position: node.position }; // รวม position ในการเปรียบเทียบ
    });

    const filteredNewNodes = newFlow.nodes.map((node) => {
        const { showHandle, ...filteredData } = node.data; // ลบ showHandle ออกจาก data
        const {
            activeSourceHandleId,
            activeTargetHandleId,
            highlighted,
            ...withoutHandleActive
        } = filteredData;
        return { id: node.id, data: withoutHandleActive, position: node.position }; // รวม position ในการเปรียบเทียบ
    });

    const filteredPrevEdges = prevFlow.edges.map((edge) => ({
        id: edge.id,
        source: edge.source,
        target: edge.target,
    }));

    const filteredNewEdges = newFlow.edges.map((edge) => ({
        id: edge.id,
        source: edge.source,
        target: edge.target,
    }));

    const prevNodesHash = await hashData(filteredPrevNodes);
    const newNodesHash = await hashData(filteredNewNodes);
    const prevEdgesHash = await hashData(filteredPrevEdges);
    const newEdgesHash = await hashData(filteredNewEdges);

    // if (prevNodesHash !== newNodesHash) {
    //     console.log("Nodes changed");
    // }
    // if (prevEdgesHash !== newEdgesHash) {
    //     console.log("Edges changed");
    // }

    // เปรียบเทียบ hash
    return prevNodesHash !== newNodesHash || prevEdgesHash !== newEdgesHash;
};

export default hasFlowChanged